import performanceCodeService from '@/core/collections/contracts-api/performance-codes/performance-code.service';
import { LocationQuery } from 'vue-router';
import { PerformanceCode } from './performance-code.interface';

export interface PerformanceCodeState {
   painterPerformanceCodes: Array<PerformanceCode>;
   performanceCodes: Array<PerformanceCode>;
   fictional_contract_allowed?: boolean;
}

const state: PerformanceCodeState = {
   painterPerformanceCodes: [],
   performanceCodes: [],
};

const getters = {
   painterPerformanceCodes(state: PerformanceCodeState) {
      return state.painterPerformanceCodes;
   },
};

const mutations = {
   SET_PAINTER_PERFORMANCE_CODES(state: PerformanceCodeState, painterPerformanceCodes: Array<PerformanceCode>) {
      state.painterPerformanceCodes = painterPerformanceCodes;
   },
   SET_PERFORMANCE_CODES(state: PerformanceCodeState, performanceCodes: Array<PerformanceCode>) {
      state.performanceCodes = performanceCodes;
   },
};

const actions = {
   async getPerformanceCodes(context: any, query: LocationQuery) {
      const performanceCodes = await performanceCodeService.getPerformanceCodes(query);
      context.commit('SET_PERFORMANCE_CODES', performanceCodes.data);
      return performanceCodes.data;
   },

   async getPerformanceCode(context: any, performanceCodeId: number) {
      return await performanceCodeService.getPerfromanceCode(performanceCodeId);
   },

   async getPainterPerformanceCodes(context: any) {
      return await performanceCodeService.getPainterPerformanceCodes().then((response) => {
         context.commit('SET_PAINTER_PERFORMANCE_CODES', response);
         return response;
      });
   },
   async getFeePerformanceCodes(context: any, payload: { customerId: number; query: LocationQuery }) {
      return await performanceCodeService.getFeePerformanceCodes(payload.customerId, payload.query);
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
